import React from 'react'
import { useCreateNode } from '../../Hooks/Features/SurveyManagement/SurveyNode/useCreateNode'
import { renderField } from '../../utils/Helper';
import CommonFilterDropdown from '../CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "underscore";

const CreateNode = ({ editNode, onClose, nodeOptions }) => {

    const { fields, formValues, setFormValues, filterValues, setFilterValues, columns, rowData, loader, upsertNode, onReset, options } = useCreateNode({ editNode, onClose, nodeOptions });

    return (
        <div className='h-100'>
            <div className='d-flex' style={{ height: "calc(100% - 30px)" }}>
                <div className='pe-3 border-end w30 h-100'>
                    {fields?.map((item, index) => (
                        renderField(item, index, (e, is_edit) => { setFormValues((prev) => ({ ...prev, [item?.name]: e?.target?.value })); }, formValues, {}, {}, () => { }, () => { })
                    ))}
                    <div style={{ height: "calc(100% - 150px)" }}>
                        <div>Active Relations</div>
                        <div className='h-100 border rounded overflow-y-auto'>
                            {options?.pairs?.map((pair, index) => {
                                const isSelected = _.some(formValues?.activePairs, item => _.isEqual(item, pair));
                                return <div key={index} className='d-flex gap-2 align-items-center p-2'>
                                    <input type='checkbox' className='c-pointer' value={isSelected} checked={isSelected} onChange={(e) => setFormValues((prev) => ({ ...prev, activePairs: e?.target?.checked ? [...(prev?.activePairs || []), pair] : prev?.activePairs?.filter(item => !_.isEqual(item, pair)) }))} id={`${pair?.from_relation_id}-${pair?.to_relation_id}`} />
                                    <label htmlFor={`${pair?.from_relation_id}-${pair?.to_relation_id}`} className={`c-pointer ${isSelected && "fw-semibold"}`}>{pair?.from_relation_name} to {pair?.to_relation_name}</label>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
                <div className='w70 ps-3'>
                    <div className='d-flex align-items-center justify-content-between'>
                        <div className='w90 d-flex gap-2 align-items-center'>
                            <input className='w15 sk-input-dd' placeholder='Search Member...' value={filterValues?.search} onChange={(e) => setFilterValues((prev) => ({ ...prev, search: e?.target?.value }))} />
                            <div className='w55'>
                                <CommonFilterDropdown fields={[{ key: "projects", label: "Projects", col: 4 }, { key: "project_leads", label: "Leads", col: 4, restrictDefault: true }, { key: "user_status", label: "Status", col: 4 }]} filterValues={filterValues} setFilterValues={setFilterValues} />
                            </div>
                            {filterValues?.projects?.length > 0 && <div className='d-flex align-items-center gap-1'>
                                <input type='checkbox' id='active-members' checked={filterValues?.showActive} onChange={(e) => setFilterValues((prev) => ({...prev, showActive: e?.target?.checked, apiCall: true}))}/>
                                <label htmlFor="active-members">Active Members Only</label>
                            </div>}
                        </div>
                        <div className='d-flex gap-2 justify-content-end w10'>
                            <button className='sk-btn sk-btn-primary' onClick={() => setFilterValues((prev) => ({ ...prev, showSelected: !prev?.showSelected }))} title={filterValues?.showSelected ? "View All" : "View Selected"}><FontAwesomeIcon icon={`fa-solid fa-${filterValues?.showSelected ? "users" : "user-check"}`} /></button>
                            <button className='sk-btn sk-btn-primary' onClick={() => setFilterValues((prev) => ({ ...prev, apiCall: true }))} title='Refresh'><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                        </div>
                    </div>
                    <div className='mt-1 overflow-y-auto' style={{ height: "calc(100% - 50px)" }}>
                        <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData }]} headerHeight={40} rowHeight={35} strippedTable={true} loader={loader?.grid} />
                    </div>
                </div>
            </div>
            <div className='d-flex gap-1 justify-content-end'>
                <button className='sk-btn sk-btn-primary' onClick={() => onReset()}>Reset</button>
                {loader?.btn ?
                    <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "50px" }}>
                        <div className="spinner-border" role="status" style={{ width: "12px", height: "12px" }}>
                            <span className="sr-only"></span>
                        </div>
                    </button> :
                    <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => upsertNode()}>Save</button>
                }
            </div>
        </div>
    )
}

export default CreateNode